export default "__VITE_ASSET__BYZQluw1__"